
export class ObjectRelationFilterOptions {
    relationTypeIds: number;
    primaryTargetObjectIds: Array<number>;
    foreignTargetObjectIds: Array<number>;
    relationshipOwnerIds:  Array<number>; 
}
